import React, { useState } from "react";
import _ from "lodash";

import PropertyMaps from "../constants/PropertyMaps";
import StyleUtils from "../utils/StyleUtils";
import { generateFontsTagsFromDesignContext } from "../utils/FontUtils";
import { FRAME_RESET_CSS } from "./ThemeStyleFrame";

const { STYLE_PROPS_THEME_INLINE_LINK, STYLE_PROPS_THEME_TEXT } = PropertyMaps;

const LOREM_IPSUM = `ipsum dolor sit amet consec tetur adip isic ing elit. Maxime mollitia,
molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum
numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium
optio, eaque rerum! Provident similique accusantium nemo autem. Veritatis
obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam
nihil, eveniet aliquid culpa officia aut! Impedit sit sunt quaerat, odit,
tenetur error, harum nesciunt ipsum debitis quas aliquid. Reprehenderit,
quia. Quo neque error repudiandae fuga? Ipsa laudantium molestias eos
sapiente officiis modi at sunt excepturi expedita sint? Sed quibusdam
recusandae alias error harum maxime adipisci amet laborum. Perspiciatis
minima nesciunt dolorem! Officiis iure rerum voluptates a cumque velit
quibusdam sed amet tempora. Sit laborum ab, eius fugit doloribus tenetur
fugiat, temporibus enim commodi iusto libero magni deleniti quod quam
consequuntur! Commodi minima excepturi repudiandae velit hic maxime
doloremque. Quaerat provident commodi consectetur veniam similique ad
earum omnis ipsum saepe, voluptas, hic voluptates pariatur est explicabo
fugiat, dolorum eligendi quam cupiditate excepturi mollitia maiores labore
suscipit quas? Nulla, placeat. Voluptatem quaerat non architecto ab laudantium
modi minima sunt esse temporibus sint culpa, recusandae aliquam numquam
totam ratione voluptas quod exercitationem fuga. Possimus quis earum veniam
quasi aliquam eligendi, placeat qui corporis!`;

const PREVIEW_LINE_CLAMP_MAP = {
  desktop_title: 2,
  desktop_heading: 2,
  desktop_subheading: 2,
  desktop_paragraph: 4,
  mobile_title: 3,
  mobile_heading: 3,
  mobile_subheading: 4,
  mobile_paragraph: 11,
};

const ThemeStylePreview = ({
  designContext,
  selectedType = "title",
  layout,
  theme,
  onClick,
  mergedSyncProps: styleProps,
  mergedLinkSyncProps,
  themeStyle,
  showInlineLinkPreview = false,
}) => {
  const [hovering, setHovering] = useState(false);
  const _getFontTags = (font) => {
    const tags = [];
    if (font) {
      tags.push(...generateFontsTagsFromDesignContext([font.toJS()], designContext));
    }
    tags.push(
      <style key="page-style" type="text/css">
        {FRAME_RESET_CSS}
      </style>
    );
    return { tags };
  };

  const styleName = themeStyle.get("name");
  const type = themeStyle.get("id");

  let styleLinkProps = mergedLinkSyncProps;
  if (hovering) {
    styleLinkProps = styleLinkProps.set("c", styleLinkProps.get("hC", `${styleProps.get("c")}:80`));
    styleLinkProps = styleLinkProps.set("tD", styleLinkProps.get("hTd", styleLinkProps.get("tD")));
    styleLinkProps = styleLinkProps.set("hTd", styleLinkProps.get("hTd"));
  }
  const style = StyleUtils.getStyle(STYLE_PROPS_THEME_TEXT, styleProps, theme);
  const linkStyle = StyleUtils.getStyle(STYLE_PROPS_THEME_INLINE_LINK, styleLinkProps, theme);

  const fontName = styleProps.get("font");
  const font = theme.getIn(["fonts", fontName]);
  const fontInfo = _getFontTags(font);
  const headerStyle = { display: "none" };

  return (
    <div
      onClick={onClick}
      style={{ position: "relative", display: "table", width: "100%", cursor: "pointer" }}
    >
      <div style={headerStyle}>{fontInfo.tags}</div>
      <div
        style={{
          overflow: "hidden",
          padding: "0 25px",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: PREVIEW_LINE_CLAMP_MAP[`${layout}_${type}`],
          wordBreak: "break-word",
          overflowWrap: "break-word",
          ...style,
        }}
      >
        {selectedType === type && (
          <div
            style={{
              position: "absolute",
              backgroundColor: "#2e97c2",
              width: "5px",
              height: `calc(100% - ${style.marginBottom || "10px"})`,
              left: 0,
            }}
          />
        )}
        {styleName}
        {showInlineLinkPreview ? (
          <>
            &nbsp;
            <span
              onMouseLeave={() => setHovering(false)}
              onMouseEnter={() => setHovering(true)}
              style={linkStyle}
            >
              inline link
            </span>
          </>
        ) : (
          ""
        )}{" "}
        {LOREM_IPSUM}
      </div>
    </div>
  );
};

export default ThemeStylePreview;
